import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../../store/action/post";
import "react-toastify/dist/ReactToastify.css";
import {
  renderFormField,
  renderTextAreaField
} from "../../../utils/reduxField";
import { Field, reduxForm, formValueSelector, change } from "redux-form";
import { validateCreatePostForm } from "../../../utils/formValidation";
import Modal from "react-bootstrap/Modal";
import fetchAiRecommend from "../../../utils/AiRecommend.jsx";
import localStore from 'src/utils/local-storage';
import countWordsHTML from 'src/utils/countWordsHTML';

const validate = values => {
  return validateCreatePostForm(values, false);
};
const maxLength = max => value =>
  value && value.length > max ? `Độ dài tối đa ${max} ký tự` : undefined;

class DescriptionTab extends Component {
  constructor(props) {
    super(props);
    const aiLimitWords = localStore.get("_aiLimitWord");
    this.state = {
      startDate: null,
      changeDesGoogle: false,
      timer: null,
      show: false,
      suggestedDescriptions: [],
      isLoading: false,
      content: '',
      lengthContent: (aiLimitWords && aiLimitWords.content) ? aiLimitWords.content : 200,
      noContent: false,
      lastFetchedContent: '', // Add this to track last fetched content
      descriptionGoogleError: false,
      descriptionGoogleHighlight: false,
      descriptionHighlight: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { post: { currentPost }, config: nextConfig } = nextProps || this.props;
    let { content, lengthContent } = this.state
    if(currentPost.content && countWordsHTML(currentPost.content) >= lengthContent){
      this.setState({
        content : currentPost.content, 
      });
    } else {
      this.setState({
        content: ''
      })
    }

    // this.getData(nextProps);
  }

  getData(props) {
       
  }


  componentDidMount() {
    const { description, description_google } = this.props.post.currentPost;

    if (!(description_google && description)) {
      this.setState({ changeDesGoogle: true });
    }
    this.getData();
  }


  componentDidUpdate(prevProps) {
    const { fields } = this.props;
    const { fields: prevFields } = prevProps;

    if (fields.description !== prevFields.description) {
      this.updateFieldData(fields, 'description', 'description_google');
    }

    if (fields.description_google !== prevFields.description_google) {
      this.updateFieldData(fields, 'description_google');
    }
  }

  updateFieldData = (data, fieldName, secondFieldName = null) => {
    this.state.timer && clearTimeout(this.state.timer);

    const { post, checkRequireData } = this.props;

    const timer = setTimeout(() => {
      post.currentPost[fieldName] = data[fieldName];

      if (secondFieldName) {
        if (this.state.changeDesGoogle) {
          let des_google = post.currentPost[fieldName].split('.')[0];
          des_google = des_google.length > 160 ? des_google.slice(0, 160) : des_google;
          this.props.changeFieldValue(secondFieldName, des_google);
          checkRequireData(post.currentPost, 17);
        }
      }

      this.props.setCurrentPost(post.currentPost);
    }, 1000);

    this.setState({ timer });
  };

  checkDescription = async () => {
    const { post: {currentPost} } = this.props;
    const content = currentPost.content;

    if (!content || countWordsHTML(content) < this.state.lengthContent) {
      this.setState({ show: true, noContent: true });
      return;
    }

    // Check if content has changed since last fetch
    const shouldFetch = content !== this.state.lastFetchedContent || this.state.suggestedDescriptions.length === 0;

    if (shouldFetch) {
      this.setState({ isLoading: true, show: true, noContent: false });
      const response = await fetchAiRecommend(content, 'sapo-recommendation');
      this.setState({
        suggestedDescriptions: response.sapos,
        isLoading: false,
        lastFetchedContent: content // Update last fetched content
      });
    } else {
      this.setState({ show: true, noContent: false });
    }
  }

  reloadSapoRecommendation = async () => {
    const { post: {currentPost} } = this.props;
    const content = currentPost.content;

    if (!content || countWordsHTML(content) < this.state.lengthContent) {
      this.setState({ show: true, noContent: true });
      return;
    }

    this.setState({ isLoading: true });
    const response = await fetchAiRecommend(content, 'sapo-recommendation');
    this.setState({
      suggestedDescriptions: response.sapos,
      isLoading: false,
      lastFetchedContent: content
    });
  }

  handleClose = () => {
    this.setState({ show: false });
  }

  selectDescription = (description) => {
    try {
      if (!description) {
        throw new Error('Description is empty');
      }
      this.setState({ show: false });
      this.props.changeFieldValue('description', description);
      this.setState({
        descriptionHighlight: true
      });
      setTimeout(() => {
        this.setState({ descriptionHighlight: false });
      }, 600);
      // Update description_google if changeDesGoogle is true
      if (this.state.changeDesGoogle) {
        let des_google = description.split('.')[0];
        des_google = des_google.length > 160 ? des_google.slice(0, 160) : des_google;
        this.props.changeFieldValue('description_google', des_google);
      }
    } catch (error) {
      console.error('Error in selectDescription:', error);
    }
  }

  copyDescription = () => {
    const { fields, changeFieldValue } = this.props;
    if (fields && fields.description) {
      changeFieldValue('description_google', fields.description);
    }
    this.setState({
      descriptionGoogleError: fields.description.length > 160,
      descriptionGoogleHighlight: true
    })

    setTimeout(() => {
      this.setState({ descriptionGoogleHighlight: false });
    }, 600);
  }

  render() {
    const { type, label, layoutName, checkClass, checkRequireData, post } = this.props;
    return (
      <div className={layoutName !== "layout-pc" ? "row card" : ""}>
        {layoutName !== "layout-pc" && (
          <div className={"d-flex align-items-center justify-content-between card-header col-12 " + checkClass}>
            <h4 className="card-title flex-grow-1">Tóm tắt nội dung</h4>
            <button type="button" className="btn btn-ai-recommend" onClick={this.checkDescription}>
              <span className="mr-2">
              <svg fillRule="evenodd" viewBox="64 64 896 896" focusable="false" dataIcon="open-a-i" width="16px" height="16px" fill="currentColor" ariaHidden="true"><path d="M482.88 128c-84.35 0-156.58 52.8-185.68 126.98-60.89 8.13-115.3 43.63-146.6 97.84-42.16 73-32.55 161.88 17.14 224.16-23.38 56.75-19.85 121.6 11.42 175.78 42.18 73.02 124.1 109.15 202.94 97.23C419.58 898.63 477.51 928 540.12 928c84.35 0 156.58-52.8 185.68-126.98 60.89-8.13 115.3-43.62 146.6-97.84 42.16-73 32.55-161.88-17.14-224.16 23.38-56.75 19.85-121.6-11.42-175.78-42.18-73.02-124.1-109.15-202.94-97.23C603.42 157.38 545.49 128 482.88 128m0 61.54c35.6 0 68.97 13.99 94.22 37.74-1.93 1.03-3.92 1.84-5.83 2.94l-136.68 78.91a46.11 46.11 0 00-23.09 39.78l-.84 183.6-65.72-38.34V327.4c0-76 61.9-137.86 137.94-137.86m197.7 75.9c44.19 3.14 86.16 27.44 109.92 68.57 17.8 30.8 22.38 66.7 14.43 100.42-1.88-1.17-3.6-2.49-5.53-3.6l-136.73-78.91a46.23 46.23 0 00-46-.06l-159.47 91.1.36-76.02 144.5-83.41a137.19 137.19 0 0178.53-18.09m-396.92 55.4c-.07 2.2-.3 4.35-.3 6.56v157.75a46.19 46.19 0 0022.91 39.9l158.68 92.5-66.02 37.67-144.55-83.35c-65.86-38-88.47-122.53-50.45-188.34 17.78-30.78 46.55-52.69 79.73-62.68m340.4 79.93l144.54 83.35c65.86 38 88.47 122.53 50.45 188.34-17.78 30.78-46.55 52.69-79.73 62.68.07-2.19.3-4.34.3-6.55V570.85a46.19 46.19 0 00-22.9-39.9l-158.69-92.5zM511.8 464.84l54.54 31.79-.3 63.22-54.84 31.31-54.54-31.85.3-63.16zm100.54 58.65l65.72 38.35V728.6c0 76-61.9 137.86-137.94 137.86-35.6 0-68.97-13.99-94.22-37.74 1.93-1.03 3.92-1.84 5.83-2.94l136.68-78.9a46.11 46.11 0 0023.09-39.8zm-46.54 89.55l-.36 76.02-144.5 83.41c-65.85 38-150.42 15.34-188.44-50.48-17.8-30.8-22.38-66.7-14.43-100.42 1.88 1.17 3.6 2.5 5.53 3.6l136.74 78.91a46.23 46.23 0 0046 .06z"></path></svg>
              </span>
              Gợi ý AI
            </button>
          </div>
        )}
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Gợi ý nội dung tóm tắt</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.noContent ? (
              <div className="text-center">Chưa có nội dung hoặc nội dung chưa đủ {this.state.lengthContent} từ, không thể gợi ý nội dung</div>
            ) : this.state.isLoading ? (
              <div className="ai-loading-container">
                  <div className="ai-icon-container">
                      <svg fillRule="evenodd" viewBox="64 64 896 896" focusable="false" dataIcon="open-a-i" width="32px" height="32px" fill="#6366f1" ariaHidden="true" className="rotating-icon">
                          <path d="M482.88 128c-84.35 0-156.58 52.8-185.68 126.98-60.89 8.13-115.3 43.63-146.6 97.84-42.16 73-32.55 161.88 17.14 224.16-23.38 56.75-19.85 121.6 11.42 175.78 42.18 73.02 124.1 109.15 202.94 97.23C419.58 898.63 477.51 928 540.12 928c84.35 0 156.58-52.8 185.68-126.98 60.89-8.13 115.3-43.62 146.6-97.84 42.16-73 32.55-161.88-17.14-224.16 23.38-56.75 19.85-121.6-11.42-175.78-42.18-73.02-124.1-109.15-202.94-97.23C603.42 157.38 545.49 128 482.88 128m0 61.54c35.6 0 68.97 13.99 94.22 37.74-1.93 1.03-3.92 1.84-5.83 2.94l-136.68 78.91a46.11 46.11 0 00-23.09 39.78l-.84 183.6-65.72-38.34V327.4c0-76 61.9-137.86 137.94-137.86m197.7 75.9c44.19 3.14 86.16 27.44 109.92 68.57 17.8 30.8 22.38 66.7 14.43 100.42-1.88-1.17-3.6-2.49-5.53-3.6l-136.73-78.91a46.23 46.23 0 00-46-.06l-159.47 91.1.36-76.02 144.5-83.41a137.19 137.19 0 0178.53-18.09m-396.92 55.4c-.07 2.2-.3 4.35-.3 6.56v157.75a46.19 46.19 0 0022.91 39.9l158.68 92.5-66.02 37.67-144.55-83.35c-65.86-38-88.47-122.53-50.45-188.34 17.78-30.78 46.55-52.69 79.73-62.68m340.4 79.93l144.54 83.35c65.86 38 88.47 122.53 50.45 188.34-17.78 30.78-46.55 52.69-79.73 62.68.07-2.19.3-4.34.3-6.55V570.85a46.19 46.19 0 00-22.9-39.9l-158.69-92.5zM511.8 464.84l54.54 31.79-.3 63.22-54.84 31.31-54.54-31.85.3-63.16zm100.54 58.65l65.72 38.35V728.6c0 76-61.9 137.86-137.94 137.86-35.6 0-68.97-13.99-94.22-37.74 1.93-1.03 3.92-1.84 5.83-2.94l136.68-78.9a46.11 46.11 0 0023.09-39.8zm-46.54 89.55l-.36 76.02-144.5 83.41c-65.85 38-150.42 15.34-188.44-50.48-17.8-30.8-22.38-66.7-14.43-100.42 1.88 1.17 3.6 2.5 5.53 3.6l136.74 78.91a46.23 46.23 0 0046 .06z"></path>
                      </svg>
                      <div className="pulse-ring">                                   
                      </div>                                
                  </div>
                  <div className="loading-text">
                      <div className="d-flex align-items-center">AI đang phân tích  
                          <div className="loading-dots" style={{ marginLeft: '10px' }}>
                              <span>•</span>
                              <span>•</span>
                              <span>•</span>
                          </div>
                      </div>
                  </div>                            
              </div>
            ) : (
              <>
                <table className="table table-bordered mt-3">
                  <thead>
                    <tr>
                      <th style={{ width: "10px" }}></th>
                      <th>Nội dung gợi ý</th>
                      <th style={{ width: "100px" }}>Chọn</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.suggestedDescriptions.map((description, idx) => (
                      <tr key={`suggestion-${idx}`}>
                        <td>{idx + 1}.</td>
                        <td>{description}</td>
                        <td>
                          <button 
                            className="btn btn-sm btn-primary"
                            onClick={() => this.selectDescription(description)}
                          >
                            Chọn
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="text-center">
                  <button className="btn btn-ai-recommend" onClick={this.reloadSapoRecommendation}>
                    Thêm gợi ý khác <i className="fas fa-sync ml-2"></i>
                  </button>                  
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        <div className="card-body col-12">
          <Field
            readonly={this.props.readonly}
            id="description"
            name="description"
            component={renderTextAreaField}
            label="Tóm tắt nội dung"
            classinput={`form-control ${this.state.descriptionHighlight ? 'highlight-border' : ''}`}
          />
          <button className="btn btn-sm btn-primary mb-2" onClick={this.copyDescription}>
            Lấy nội dung tóm tắt
          </button>
          <Field
            classinput={`form-control ${this.state.descriptionGoogleHighlight ? 'highlight-border' : ''}`}
            classgroup="form-group"
            id="description_google"
            name="description_google"
            component={renderTextAreaField}
            label="Tóm tắt nội dung hiển thị trên Google (độ dài tối đa 160 ký tự)"
            maxLength="160"
            onKeyUp={() => { this.setState({ changeDesGoogle: false }) }}
            onBlur={(event, newValue, previousValue, name) => {
              checkRequireData(post.currentPost, 17);
            }}
          />
          {this.state.descriptionGoogleError && 
            <div className="text-danger mb-2" style={{fontSize: '12px', marginTop: '-8px'}}>Nội dung tóm tắt google đã vượt quá 160 kí tự</div>
          }
        </div>
      </div>
    );
  }
}
const selector = formValueSelector("formPostEdit");
DescriptionTab = reduxForm({
  form: "formPostEdit",
  validate,
  asyncBlurFields: ['description', 'description_google']
})(DescriptionTab);

export default connect(
  store => {
    return {
      post: store.post,
      form: store.formPostEdit,
      fields: selector(store, "description_google", "description")
    };
  },
  dispatch => {
    return {
      setCurrentPost: value => {
        dispatch(postActions.setCurrentPost(value));
      },
      changeFieldValue: (field, value) => {
        dispatch(change("formPostEdit", field, value));
      }
    };
  }
)(DescriptionTab);
